import { render, staticRenderFns } from "./add_class.vue?vue&type=template&id=0a99125a&"
import script from "./add_class.vue?vue&type=script&lang=js&"
export * from "./add_class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports